import React from "react";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { OpButton } from "components/customAntd/DLS/OpButton/OpButton";

const { Option } = Select;

interface SelectionPageProps {
  onSignIn: () => void;
  onSignOut: () => void;
  allowSelfSignIn?: number;
  allowSelfSignOut?: number;
  onLanguageChange?: (language: string) => void;
  currentLanguage?: string;
}

const SelectionPage: React.FC<SelectionPageProps> = ({
  onSignIn,
  onSignOut,
  allowSelfSignIn = 1,
  allowSelfSignOut = 1,
  onLanguageChange,
  currentLanguage,
}) => {
  const { t, i18n } = useTranslation();

  const supportedLangs = ['en', 'es', 'de', 'it', 'fr', 'pt'];
  const defaultLang = currentLanguage || (supportedLangs.includes(i18n.language)
    ? i18n.language
    : (supportedLangs.includes(i18n.language.split('-')[0])
      ? i18n.language.split('-')[0]
      : 'en'));

  const handleLanguageChange = (lang: string) => {
    if (onLanguageChange) {
      onLanguageChange(lang);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "32px",
        width: "100%",
        maxWidth: "400px",
        margin: "auto",
      }}
    >
      {/* Sign In/Out Buttons */}
      <div
        className="button-container"
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "32px",
          width: "100%",
        }}
      >
        {allowSelfSignIn === 1 && (
          <OpButton
            type="primary"
            size="large"
            className="signin-button"
            onClick={onSignIn}
          >
            {t("selfSignIn.selection.signIn")}
          </OpButton>
        )}
        {allowSelfSignOut === 1 && (
          <OpButton
            type="primary"
            size="large"
            className="signout-button"
            onClick={onSignOut}
          >
            {t("selfSignIn.selection.signOut")}
          </OpButton>
        )}
      </div>

      {/* Language Selection - Bottom */}
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '8px' }}>
        <Select
          value={defaultLang}
          onChange={handleLanguageChange}
          style={{ width: 150 }}
          size="large"
        >
          <Option value="en">English</Option>
          <Option value="es">Español</Option>
          <Option value="de">Deutsch</Option>
          <Option value="it">Italiano</Option>
          <Option value="fr">Français</Option>
          <Option value="pt">Português</Option>
        </Select>
      </div>
    </div>
  );
};

export default SelectionPage;
